@if (landingPageDataService.details()) {
  <div
    class="post__url"
    [ngClass]="{ 'choose-open': !platformService.isMobile }"
  >
    <a
      class="url__link"
      [href]="landingPageDataService.details().url"
      [innerText]="landingPageDataService.details().url || '' | ellipsis: 30"
      rel="nofollow"
    ></a>

    @if (!platformService.isMobile) {
      <div class="tabs flex justify-center gap-6">
        <a
          class="primary__btn-outline w-full"
          [href]="landingPageDataService.details().url"
          rel="nofollow"
          translate
          >Open Here</a
        >
        <a
          class="primary__btn-outline w-full"
          [href]="landingPageDataService.details().url"
          rel="nofollow"
          target="_blank"
          translate
          >Open New Tab</a
        >
      </div>
    }
  </div>
}
